import { render, staticRenderFns } from "./InvestorEventsProjectComponent.vue?vue&type=template&id=8d0c7d2e&scoped=true"
import script from "./InvestorEventsProjectComponent.vue?vue&type=script&lang=js"
export * from "./InvestorEventsProjectComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d0c7d2e",
  null
  
)

export default component.exports